import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  tracking_response_model,
  tracking_response_item_model,
} from '../tracking-item.model';
// declare var QRCode: any;
import QRCode from 'easyqrcodejs';
@Component({
  selector: 'tracking-item-photo-dialog',
  templateUrl: 'tracking-item-photo-dialog.html',
})
export class TrackingItemPhotoDialog implements OnInit {
  @ViewChild('qrcode', { static: true }) qrcode: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: tracking_response_item_model
  ) {}

  ngOnInit() {
    new QRCode(this.qrcode.nativeElement, {
      text:
        ' https://campaign.th.kex-express.com/event/link?p=tracking&id=' +
        this.data.shipment.con +
        '-img', //this.data.shipment.img,
      logo: 'assets/resource/ke-favicon.png',
      logoWidth: 30,
      logoHeight: 30,
      logoBackgroundColor: '#ffffff',
      logoBackgroundTransparent: false,
      width: 180,
      height: 180,
    });
  }
  parseScheme(s, device) {
    // _device = device;
    // https://th.kex-express.com/__openapp/open.html?hl=th
    if (s === 'main') return '';

    // https://th.kex-express.com/__openapp/open.html?hl=th&page=tracking
    if (s === 'tracking') return 'tracking';

    // https://th.kex-express.com/__openapp/open.html?hl=th&page=booking
    if (s === 'booking') return 'booking';

    var v;
    // https://th.kex-express.com/__openapp/open.html?hl=th&page=tracking?KE1234
    v = /tracking\?\w+/.exec(s);
    if (v !== null) {
      var name = device === 'ANDROID' ? 'consignment=' : '';
      return 'tracking?' + name + v[0].substring(9);
    }

    return 'main';
  }
  openApp() {
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      let storeUrl =
          'https://itunes.apple.com/th/app/kerry-express/id909585896?l=th',
        scheme = this.parseScheme('tracking', 'IOS'),
        fallbackUrl = encodeURIComponent(storeUrl),
        //appUrl = 'intent://' + scheme + '#Intent;scheme=keapp;package=kerry.express.th.mobile.tracking;S.browser_fallback_url=' + fallbackUrl + ';end;';
        appUrl = 'keapp://' + scheme;
      // open_store(appUrl)
      this.open_store(appUrl);
    } else if (navigator.userAgent.match(/Android/i)) {
      let storeUrl = 'market://details?id=kerry.express.th.mobile.tracking',
        scheme = this.parseScheme('tracking', 'ANDROID'),
        fallbackUrl = encodeURIComponent(storeUrl),
        // appUrl = 'kerry://' + scheme;
        appUrl =
          'intent://' +
          scheme +
          '#Intent;scheme=keapp;package=kerry.express.th.mobile.tracking;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;end;S.browser_fallback_url=' +
          fallbackUrl +
          ';end;';
      this.open_store(appUrl);
    }
  }

  open_store(storeUrl) {
    let tmp: any = window.location.href;
    window.location.href = storeUrl;
    setTimeout(function () {
      window.location = tmp;
    }, 1000);
  }
}
